import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {AbstractionComponent} from "@biletix/core/common/abstraction-component";
import {NavItem} from "@biletix/core/view-models/nav-item.model";
import {ActivatedRoute, Router} from "@angular/router";
import {NavigationService} from "@biletix/core/services/navigation.service";

@Component({
  selector: 'btx-side-nav-link',
  templateUrl: './side-nav-link.component.html',
  styleUrls: ['./side-nav-link.component.scss'],
  animations: [
    trigger('indicatorRotate', [
        state('collapsed', style({transform: 'rotate(0deg)'})),
        state('expanded', style({transform: 'rotate(180deg)'})),
        transition('expanded <=> collapsed',
          animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
        ),
      ]
    )
  ],
  standalone: false
})
export class SideNavLinkComponent extends AbstractionComponent implements OnInit {


@HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;

@Input() item: NavItem | any;

@Input() depth: number = 0;

private _expanded: boolean = false;

private _active: boolean = false;

  /**
   * TODO: Bu komponenti güncelenecek. fonksiyonalite sağlanacak.
   * @param activatedRoute
   * @param router
   */
  constructor(private activatedRoute: ActivatedRoute,
    private navigationService: NavigationService,
    public router: Router) {
    super();

  }

  /**
   * TODO: Menu kodları düzenlenecek.
   */
  ngOnInit() {

    //TODO: Bu kısım düzenlenecek menu açık halde getirelecek. Daha sonra bakılacak code refactor edilecek.
    this.navigationService.currentUrl
      .pipe(this.takeUntilDestroy())
      .subscribe(url => {
          // console.log(`Checking '/${this.item.route}' against '${url}'`);
          this._expanded = this.isActiveRoute(url);
          this._active = this.expanded;
          this.ariaExpanded = this.expanded;
          // console.log(`${this.item.route} is expanded: ${this.expanded}`);
        }
      );
  }

  isActiveRoute(url: string) {

    //child route
    if (this.item.children && this.item.children.length > 0) {
      return this.item.children.some((item: NavItem) => item.route && url.indexOf(`/${item.route}`) >= 0);
    }
    if (this.item.route) {
      return url.indexOf(`/${this.item.route}`) >= 0;
    }
    return false;
  }

  /**
   *
   * @param item
   */

  onItemSelected(item: NavItem) {
    this._active = !this._active;
    if (item.children && item.children.length > 0) {
      this.expanded = !this._expanded;
    } else {
      this.navigateToRoute(item.route);
    }
  }

  /**
   *
   * @param route
   */
private navigateToRoute(route?: string) {
    if (route != null) {
      this.router.navigate(
        [route],
        {
          relativeTo: this.activatedRoute
        }
      );
    }

  }

  get expanded(): boolean {
    return this._expanded;
  }

  set expanded(expanded: boolean) {
    this._expanded = expanded;
  }

  get active(): boolean {
    return this._active;
  }

  set active(value: boolean) {
    this._active = value;
  }


}
